<template>
  <Flex direction="column">
    <BaseCard gray>
      <BaseDropdown
        v-model="formData.languagePublic"
        :label="$t('giftcard_widget.settings.language')"
        :options="publicLanguages"
        v-test="'giftcard-setting-languagePublic'"
      />
    </BaseCard>
    <BaseCard gray>
      <Flex direction="column">
        <BaseCheckbox
          v-model="formData.settings.sales.giftcardExpiration"
          :label="$t('giftcard_widget.settings.expiration_date')"
          v-test="'giftcard-setting-giftcardExpiration'"
        />
        <BaseDropdown
          v-if="formData.settings.sales.giftcardExpiration"
          v-model="formData.settings.sales.giftcardExpirationValue"
          :label="$t('giftcard_widget.settings.expires_in')"
          :options="
            [2, 3, 4, 5].map((value) => ({
              value,
              label: `${value} ${$t('global.items.year', value)}`
            }))
          "
          v-test="'giftcard-setting-giftcardExpirationValue'"
        />
      </Flex>
    </BaseCard>
    <Amounts />
    <BaseCard gray>
      <BaseInput
        v-model="formData.giftcardPersonalMessage"
        type="textarea"
        :label="$t('giftcard_widget.settings.personal_message.heading')"
        :info="$t('giftcard_widget.settings.personal_message.info')"
        :maxLength="140"
        characterCount
        v-test="'giftcard-setting-giftcardPersonalMessage'"
      />
    </BaseCard>
    <IdealPayments />
  </Flex>
</template>

<script lang="ts">
export default {
  name: 'MainSettings',
};
</script>

<script
  setup
  lang="ts"
>
import { useBookingSettingsOptions } from '@/modules/admin/online-bookings/input-options';
import Amounts from './Amounts.vue';
import IdealPayments from './IdealPayments.vue';

const formData = inject<any>('giftcardSettingsData');
const { publicLanguages } = useBookingSettingsOptions();
</script>
